import { brandColors } from "../theme";

// Estilos compartidos por los dos chats de soporte: la pantalla /support/chat
// (SupportChat.js) y el asistente flotante (SupportAssistantWidget.js).

// Texto sobre el accent: es claro en los modos oscuros y oscuro en el claro.
export const onAccent = brandColors.mode === "light" ? "#ffffff" : "#0a0a1a";

export const bubbleSx = (mine, firstInGroup, lastInGroup) => {
  const side = mine ? "Right" : "Left";
  return {
    px: 1.5,
    py: 1,
    borderRadius: "16px",
    // La esquina del lado del remitente se achica donde la burbuja se une con
    // otra del mismo grupo.
    [`borderTop${side}Radius`]: firstInGroup ? "16px" : "6px",
    [`borderBottom${side}Radius`]: lastInGroup ? "16px" : "6px",
    bgcolor: mine ? brandColors.accent : "background.paper",
    color: mine ? onAccent : "text.primary",
    border: mine ? 0 : 1,
    borderColor: "divider",
  };
};

export const typingDotsSx = {
  "& span": {
    width: 6,
    height: 6,
    borderRadius: "50%",
    bgcolor: "text.secondary",
    animation: "supportTypingDot 1.2s ease-in-out infinite",
  },
  "& span:nth-of-type(2)": { animationDelay: "0.15s" },
  "& span:nth-of-type(3)": { animationDelay: "0.3s" },
  "@keyframes supportTypingDot": {
    "0%, 60%, 100%": { opacity: 0.35, transform: "translateY(0)" },
    "30%": { opacity: 1, transform: "translateY(-3px)" },
  },
  "@media (prefers-reduced-motion: reduce)": { "& span": { animation: "none" } },
};
